import { CashService } from "./../../../services/catalogs/CashService";
import React from "react";
import { CashDetail } from "../../../components/Pages/Catalogs/Cash/CashDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { CreateCashDto } from "../../../dtos/catalogs/cash/CreateCashDto";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupCash } from "../../../components/Shared/NewForms/NFLookupCash";
import CashList from "../../../components/Pages/Catalogs/Cash/CashList";

export const Cash: IAppEntity = {
  entityType: "catalog",
  title: "Cashboxes ",
  pluralTitle: "Cashboxes ",
  apiUrl: "CashBoxes",
  apiEnum: ReferenceTypes.CatalogCompanyCashBox,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(CashDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CashList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCash, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new CashService("Cashboxes"),
  getEmptyModel: () => {
    const model: CreateCashDto = {
      name: "",
      createdDate: new Date(),
    };
    return model;
  },
};
